import { Spacer, Text, Tooltip } from "@chakra-ui/react";
import { ReactNode } from "react";
import { isPathnameActive, useAppUrls } from "~/appUrls";
import { AppBar, AppBarItem } from "~/components/AppBar";
import { ContactSalesBadge } from "~/components/ContactSales/ContactSalesBadge";

import { useParams } from "react-router-dom";
import { BackgroundTasksPopover } from "~/features/backgroundTasks/BackgroundTasksPopover";
import { useFeatureFlags } from "~/features/featureFlag/hooks";
import { AppBarSimProgress } from "./AppBarSimProgress";

export function ProjectAppBar() {
  const { projectId } = useParams<{ projectId: string }>();
  const urls = useAppUrls();
  const { isSentinelDemoEnabled } = useFeatureFlags(["sentinel-demo"]);

  if (!projectId) {
    return null;
  }

  return (
    <AppBar>
      <AppBarItem
        to={urls.projectDesignBlockRoute(projectId)}
        isActive={(pathname) =>
          isPathnameActive(pathname, urls.projectDesignRoute(projectId), {
            startsWith: true,
          })
        }
      >
        Model
      </AppBarItem>
      <AppBarItem
        to={urls.projectMeteoIndexRoute(projectId)}
        isActive={(pathname) =>
          isPathnameActive(pathname, urls.projectMeteoIndexRoute(projectId), {
            startsWith: true,
          })
        }
      >
        Meteo
      </AppBarItem>
      <AppBarItem
        to={urls.projectSimBlocksRoute(projectId)}
        isActive={(pathname) =>
          isPathnameActive(pathname, urls.projectSimRoute(projectId), {
            startsWith: true,
          })
        }
      >
        Compute
      </AppBarItem>
      <AppBarItem
        to={urls.projectSimulationsIndexRoute(projectId)}
        isActive={(pathname) =>
          isPathnameActive(
            pathname,
            urls.projectSimulationsIndexRoute(projectId),
            { startsWith: true }
          )
        }
      >
        Results
      </AppBarItem>
      <AppBarItem
        to={urls.projectCompareIndexRoute(projectId)}
        isActive={(pathname) =>
          isPathnameActive(pathname, urls.projectCompareIndexRoute(projectId), {
            startsWith: true,
          })
        }
      >
        Compare
      </AppBarItem>

      {isSentinelDemoEnabled ? (
        <AppBarItem
          to={urls.projectMonitorIndexRoute(projectId)}
          isActive={(pathname) =>
            isPathnameActive(
              pathname,
              urls.projectMonitorIndexRoute(projectId),
              {
                startsWith: true,
              }
            )
          }
        >
          Monitor
        </AppBarItem>
      ) : (
        <AppBarItem to="https://enurgen.com/contact-us">
          <ContactSalesTooltip>
            <Text>Monitor</Text>
          </ContactSalesTooltip>
        </AppBarItem>
      )}
      <Spacer />

      <AppBarItem>
        <AppBarSimProgress projectId={projectId} />
      </AppBarItem>
      <AppBarItem p={0}>
        <BackgroundTasksPopover />
      </AppBarItem>
    </AppBar>
  );
}

function ContactSalesTooltip({ children }: { children: ReactNode }) {
  return (
    <Tooltip label={<ContactSalesBadge />} fontSize="md" p={0} lineHeight={6}>
      {children}
    </Tooltip>
  );
}
